
// jquery loaded using expose. Bootstrap comes in via import and doesn't need any exports
import jQuery from "expose-loader?exposes=$,jQuery!jquery";

require("./script/customized_modules/alertify/alertifybuild");

//--Our library scripts and plugins
require("./script/jquery.printarea/jquery.printarea");
require("./script/jquery.validate/jquery.validate.1.19.3");
require("./script/jquery.validate/validate.unobtrusive.mnw");
require("./script/mnw/common/jqueryplugins");

import {vld_googlerecaptcha} from "./script/mnw/common/functions";
import {ongvsuccess} from "./script/mnw/common/functions";

window.vld_googlerecaptcha = vld_googlerecaptcha;
window.ongvsuccess = ongvsuccess;

window.WebUI = require("./script/mnw/common/WebUI").WebUI;


